function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.2502 4.73831L10.4737 4.18968L8.78411 0.767555C8.48836 0.16993 7.51011 0.16993 7.21435 0.767555L5.5256 4.18968L1.74823 4.73831C1.03335 4.84243 0.74373 5.72443 1.26348 6.23193L3.99698 8.89543L3.3521 12.6571C3.23048 13.3693 3.97948 13.9162 4.62173 13.5793L7.99923 11.8039L11.3776 13.5802C12.0146 13.9136 12.7697 13.3754 12.6472 12.6579L12.0024 8.89631L14.7359 6.2328C15.2547 5.72443 14.9651 4.84243 14.2502 4.73831Z",
  fill: "#C8CACF"
});

const SvgStarIcon = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgStarIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/starIcon.7c66a687.svg";
export { ForwardRef as ReactComponent };